import {app} from '@tfx/common/app'
import {Controller} from 'stimulus'

export default class extends Controller {
  static values = {eventUrl: String}

  open() {
    const link = document.createElement('link')
    link.href = 'https://assets.calendly.com/assets/external/widget.css'
    link.rel = 'stylesheet'
    link.type = 'text/css'
    document.body.appendChild(link)

    app.Plugin.use('calendly', () => {
      window.Calendly.initPopupWidget({
        url: this.eventUrlValue
      })
    })
  }
}
